// Centralized API base URL for the application
export const API_BASE = "https://hrm.sportstech.team/api";
// "https://stelar-herbert-sinlike.ngrok-free.dev/api/";
